import React from "react";
import { Link } from "react-router-dom";

import { Button } from "reactstrap";

const Page404 = () => (
  <div className="text-center">
    <h1 className="display-1 font-weight-bold">404</h1>
    <p className="h1">잘못된 주소</p>
    <p className="h2 font-weight-normal mt-3 mb-4">
      찾으시는 화면이 없습니다
    </p>
    <Link to="/">
      <Button color="primary" size="lg">
        메인으로 이동
      </Button>
    </Link>
  </div>
);

export default Page404;
